// extracted by mini-css-extract-plugin
module.exports =  {"rankWrapper":"PerformanceTable-module__rankWrapper--rvkml"};